export const ALL_FRAGMENTS = Infinity
export const NO_FRAGMENTS = -Infinity
